(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.DOL",
            {
                url: "/DOL",
                component: "dol",
                PageTitle: "Department of Labor Updates",
                requiredPermissions: "Dol:View"
            });
        }
    ]);

    app.component("dol",
    {
        templateUrl: "App/Resources/DOL/dol.html",
        controller: dolCtrl,
        bindings: {

        }
    });

    dolCtrl.$inject = ["$filter", "wistiaApi", "permissionService", "amplitudeService"];


    function dolCtrl($filter, wistiaApi, permissionService, amplitudeService) {

        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $ctrl.loadResources = function () {

            // FYI - these resources are availabe for anyone currently

            $ctrl.loadingAssets = true;

            wistiaApi.getDolAssets().then(function (response) {

                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("unique")(projectMedias, "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                    {
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: ($filter("filter")(projectMedias, { section: value.section }))
                    }
                    $ctrl.Assets.push(newAsset);
                });
               

            }).then($ctrl.loadingAssets = false);
        }
       
        $ctrl.closeOtherAssets = function (asset) {
            ng.forEach($ctrl.Assets, function (a, key) {
                if (a.ID !== asset.ID)
                    a.Active = false;
            });
        } 

        if (permissionService.hasOnePermission("Dol:Access")) {
            $ctrl.loadResources();
        }
    }

})(window.app, window.angular); // jshint ignore:line